/**
 * Resource archive list — summary updates and mobile filter toggle.
 */
export function initResourceArchiveList() {
	const root = document.querySelector('[data-resource-archive-list]');
	if (!root) {
		return;
	}

	const summary = root.querySelector('[data-resource-archive-summary]');
	const defaultScopeLabel = root.getAttribute('data-scope-label') || 'All Resources';
	const typeFacetDefault = root.getAttribute('data-type-facet-default') || 'Type';

	const getScopeLabel = () => {
		const typeFacet = root.querySelector('.resource-archive-list__facet--resource_type .facetwp-facet');

		if (!typeFacet) {
			return defaultScopeLabel;
		}

		const labelEl = typeFacet.querySelector('.fs-label');
		const selectedLabel = labelEl?.textContent?.trim() || '';

		if (!selectedLabel || selectedLabel === typeFacetDefault) {
			return defaultScopeLabel;
		}

		return selectedLabel;
	};

	const scopeEl = summary?.querySelector('[data-resource-archive-summary-scope]');
	const countEl = summary?.querySelector('[data-resource-archive-summary-count]');

	const updateSummary = () => {
		if (!summary || typeof window.FWP === 'undefined') {
			return;
		}

		const visibleCount = root.querySelectorAll('.resource-archive-list__results .facetwp-template .resources-card').length;
		const totalFromPager = Number(window.FWP.settings?.pager?.total_rows);
		const totalCount =
			Number.isFinite(totalFromPager) && totalFromPager > 0 ? totalFromPager : visibleCount;

		if (scopeEl) {
			scopeEl.textContent = getScopeLabel();
		}

		if (countEl) {
			countEl.textContent = `(${visibleCount} of ${totalCount})`;
		}
	};

	const syncResetVisibility = () => {
		const resetWrap = root.querySelector('.resource-archive-list__filters-reset');
		if (!resetWrap) {
			return;
		}

		const facetEl = resetWrap.querySelector('.facetwp-facet');
		const isHidden = facetEl?.classList.contains('facetwp-hidden') ?? true;
		resetWrap.toggleAttribute('hidden', isHidden);
	};

	const syncPagerVisibility = () => {
		const pager = root.querySelector('.resource-archive-list__pager');
		if (!pager) {
			return;
		}

		if (typeof window.FWP === 'undefined' || !window.FWP.settings?.pager) {
			pager.toggleAttribute('hidden', true);
			return;
		}

		const loadMore = pager.querySelector('.facetwp-load-more');
		const page = Number(window.FWP.settings.pager.page) || 1;
		const totalPages = Number(window.FWP.settings.pager.total_pages) || 1;
		const shouldHide =
			loadMore?.classList.contains('facetwp-hidden') || page >= totalPages;

		pager.toggleAttribute('hidden', shouldHide);
	};

	const onFacetwpLoaded = () => {
		updateSummary();
		syncResetVisibility();
		syncPagerVisibility();
	};

	document.addEventListener('facetwp-loaded', onFacetwpLoaded);
	onFacetwpLoaded();

	const filters = root.querySelector('[data-resource-archive-filters]');
	const toggles = root.querySelectorAll('[data-resource-archive-filters-toggle]');
	const panel = root.querySelector('[data-resource-archive-filters-panel]');

	if (!filters || !toggles.length || !panel) {
		return;
	}

	const desktopQuery = window.matchMedia(`(min-width: ${getDesktopBreakpoint()}px)`);

	const setPanelOpen = (isOpen) => {
		panel.classList.toggle('is-open', isOpen);
		panel.toggleAttribute('hidden', !isOpen);
		toggles.forEach((control) => {
			control.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		});
		filters.classList.toggle('is-open', isOpen);
	};

	const syncFiltersLayout = () => {
		if (desktopQuery.matches) {
			setPanelOpen(true);
			toggles.forEach((control) => {
				control.setAttribute('tabindex', '-1');
			});
			return;
		}

		toggles.forEach((control) => {
			control.removeAttribute('tabindex');
		});
		setPanelOpen(false);
	};

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			if (desktopQuery.matches) {
				return;
			}

			setPanelOpen(!panel.classList.contains('is-open'));
		});
	});

	desktopQuery.addEventListener('change', syncFiltersLayout);
	syncFiltersLayout();
}

function getDesktopBreakpoint() {
	const value = getComputedStyle(document.documentElement).getPropertyValue('--arcadia-desktop-breakpoint').trim();
	const parsed = Number.parseInt(value, 10);

	return Number.isNaN(parsed) ? 1024 : parsed;
}
